import ftmlogo from "../../assets/images/Freshthyme_logo.png";
import React from "react";
import { useSearchParams } from "react-router-dom";
import "./NotFound.css";

const ERROR_CONFIG = {
    GEO_RESTRICTED: {
        statusCode: 403,
        title: "Location Not Supported",
        description:
            "This service is not currently available in your location.",
    },

    BLOCKED_DOMAIN: {
        statusCode: 400,
        title: "Email Domain Not Supported",
        description:
            "The email address you entered uses a domain that is not supported.",
    },

    GUARD_ERROR: {
        statusCode: 403,
        title: "Access Restricted",
        description:
            "You are not authorized to access this page. Please sign in with an eligible account.",
    },
};

const DEFAULT_ERROR = {
    statusCode: 404,
    title: "We Couldn't Find That Page",
    description:
        "The page may have been moved, deleted, or the link might be incorrect.",
};

function NotFound() {
    const [searchParams] = useSearchParams();

    const errorType = searchParams.get("errorCode");

    const {
        statusCode,
        title,
        description,
    } = ERROR_CONFIG[errorType] || DEFAULT_ERROR;

    return (
        <main
            className="not-found-page"
            aria-labelledby="not-found-title"
        >
            <div className="not-found-background-glow" />

            <section className="not-found-card">
                <a
                    href={process.env.REACT_APP_REDIRECT_URI}
                    className="not-found-logo-link"
                    aria-label="Navigate to home page"
                >
                    <img
                        src={ftmlogo}
                        alt="Fresh Thyme Market logo"
                        className="not-found-logo"
                    />
                </a>

                <div className="not-found-content">
                    <span className="not-found-badge">
                        Error {statusCode}
                    </span>

                    <h1
                        id="not-found-title"
                        className="not-found-title"
                    >
                        {title}
                    </h1>

                    <p className="not-found-description">
                        {description}
                    </p>

                </div>
            </section>
        </main>
    );
}

export default NotFound;